// extracted by mini-css-extract-plugin
export var card = "_oc-0";
export var content = "_oc-2";
export var details = "_oc-3";
export var icon = "_oc-1";
export var iconBlue = "_oc-5";
export var iconBrand = "_oc-4";
export var iconGrayBlue = "_oc-6";
export var iconGreen = "_oc-7";
export var iconIndigo = "_oc-8";
export var iconOrange = "_oc-9";
export var iconPurple = "_oc-a";
export var iconRed = "_oc-b";
export var iconWarning = "_oc-c";